import { useEffect } from "react";

// Holds the idle screen snapback while an admin data-entry modal is open (owner request 2026-11).
export function useIdleExempt(active) {
  useEffect(() => {
    if (!active) return undefined;
    document.body.dataset.idleExempt = String(Number(document.body.dataset.idleExempt || 0) + 1);
    return () => {
      const n = Number(document.body.dataset.idleExempt || 1) - 1;
      if (n > 0) document.body.dataset.idleExempt = String(n);
      else delete document.body.dataset.idleExempt;
    };
  }, [active]);
}
